export const WARNING = 'warning';
export const DANGER = 'danger';
export const SUCCESS = 'success';
export const DISABLED = 'disabled';
export const DEFAULT = 'default';
export const IMPORTANT = 'important';
export const TERTIARY = 'tertiary';
